module.exports = __webpack_public_path__ + "img/img5.701e0d9c.png";